'use strict'
module.exports = function (Yallist) {
  Yallist.prototype[Symbol.iterator] = function* () {
    for (let walker = this.head; walker; walker = walker.next) {
      yield walker.value
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonwebtoken/node_modules/yallist/iterator.js
// module id = 547
// module chunks = 1